// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3KaGG","col":"styles_col__2EDk5"};